//
//
//
//

/**
 * Original Author: Ben Layton
 * Original Team: Fore oh Four!
 */
import { VProgressLinear } from 'vuetify/lib';

export default {
  name: 'NsProgress',
  components: {
    VProgressLinear,
  },
  data() {
    return {};
  },
};
